export const reconFiltersSchema = [
  {
    id: "processor",
    label: "Processor",
    type: "text",
    multiselector: true,
    displayLogo: true,
    showTitleType: false,
    uniqueType: false,
    items: ["data is updated from api"],
  },
  {
    id: "timestamp",
    label: "Settlement Date",
    type: "date",
    multiselector: false,
    displayLogo: false,
    showTitleType: false,
    uniqueType: false,
    items: [],
  },
  {
    id: "status",
    label: "Status",
    type: "text",
    multiselector: true,
    displayLogo: false,
    showTitleType: false,
    uniqueType: false,
    items: [
      { label: "IN_PROGRESS", value: "IN_PROGRESS" },
      { label: "FAILED", value: "FAILED" },
      { label: "LOADED", value: "LOADED" },
      { label: "PROCESSED", value: "PROCESSED" },
    ],
  },

  // {
  //   id: "metadata.SETTLEMENT_CURRENCY",
  //   label: "Settlement Currency",
  //   type: "text",
  //   multiselector: true,
  //   displayLogo: false,
  //   showTitleType: false,
  //   uniqueType: false,
  //   items: [],
  // },
];
